module.exports = __webpack_public_path__ + "static/selected-language-mobile-7c25b418cc64c351e0daf3ab776a4672.png";